/** Shared Google Maps marker fill colors across manager, driver, and customer map views. */
export const MAP_MARKER_COLORS = {
  depot: '#F9A825',
  vehicle: '#1E3A5F',
  driver: '#1E3A5F',
  job: '#F4511E',
};
